
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Supabase URL from the main client
const SUPABASE_URL = "https://nbzxbqxzodcsxgwvwfnp.supabase.co";

// This is a service role API key meant to be used for administrative operations
// that need to bypass RLS policies
const SUPABASE_SERVICE_ROLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ienhicXh6b2Rjc3hnd3Z3Zm5wIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0NTk0NTQzNywiZXhwIjoyMDYxNTIxNDM3fQ.-9rM4h9sS0Uzd3zBzEwbxZUijR7STAKeyhQQNqLLEfE";

/**
 * Create a service role client to bypass RLS
 * This client will have admin privileges to insert data
 * without being restricted by RLS policies
 */
export const createServiceClient = () => {
  return createClient<Database>(
    SUPABASE_URL,
    SUPABASE_SERVICE_ROLE_KEY,
    {
      auth: {
        persistSession: false,
        autoRefreshToken: false
      },
      global: {
        headers: {
          'X-Client-Info': 'maturity-compass-admin'
        }
      }
    }
  );
};
